import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
// import { padNumber, toInteger, isNumber } from '@ng-bootstrap/ng-bootstrap/util';

import { I18n } from './custom-date-picker-i18n';

@Injectable()
export class CustomDateISOParserFormatter extends NgbDateParserFormatter {

  constructor(private _i18n: I18n) {
    super();
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      const subYear = 0; // this._i18n.getAdjustYear();
      const dateParts = value.trim().split('/');
      if (dateParts.length === 1 && this.isNumber(dateParts[0])) {
        return { year: this.toInteger(dateParts[2]) - subYear, month: null, day: null };
      } else if (dateParts.length === 2 && this.isNumber(dateParts[0]) && this.isNumber(dateParts[1])) {
        return { year: this.toInteger(dateParts[2]) - subYear, month: this.toInteger(dateParts[1]), day: null };
      } else if (dateParts.length === 3 && this.isNumber(dateParts[0]) && this.isNumber(dateParts[1]) && this.isNumber(dateParts[2]) && (dateParts[2].length === 4)) {
        return { year: this.toInteger(dateParts[2]) - subYear, month: this.toInteger(dateParts[1]), day: this.toInteger(dateParts[0]) };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    // var year = date ? date.year + this._i18n.getAdjustYear() : '';
    return date ?
      `${this.isNumber(date.day) ? this.padNumber(date.day) : ''}/${this.isNumber(date.month) ? this.padNumber(date.month) : ''}/${date.year}` :
      '';
  }

  toInteger(value) {
    return parseInt("" + value, 10);
  }

  isNumber(value) {
    return !isNaN(this.toInteger(value));
  }

  padNumber(value) {
    if (this.isNumber(value)) {
      return ("0" + value).slice(-2);
    }
    else {
      return '';
    }
  }
}
